function sendChange(form, btn, allInput) {
	const url = '/ajax/form.php';
	const data = new URLSearchParams();
	const formData = new FormData(form);

	for (const pair of formData) {
		data.append(pair[0], pair[1]);
	}

	fetch(url, {
		method: 'post',
		body: data,
	}).then((response) => {
		if (response.status < 200 || response.status > 300) {
			let error = new Error(response.statusText);
			error.response = response;
			throw error;
		} else {
			btn.classList.remove('btn-save-change');
			btn.innerText = 'Изменить';
			allInput.forEach((input) => {
				input.disabled = true;
			});

			return response;
		}
	});
}

function changeVote(btn) {
	const form = btn.closest('form');
	const allInput = form.querySelectorAll('input');

	if (btn.classList.contains('btn-save-change')) {
		sendChange(form, btn, allInput);
	} else {
		btn.classList.add('btn-save-change');
		btn.innerText = 'Сохранить';
		allInput.forEach((input) => {
			input.disabled = false;
		});
	}
}

function init() {
	document.addEventListener('click', (e) => {
		if (e.target.classList.contains('lichnyj-kabinet__nominate-item-btn')) {
			changeVote(e.target);
		}
	});
}

export default {
	init,
};
